<template>
  <div class="bg-white py-2">
    <b-row class="px-0 mx-0">
      <b-icon
        icon="skip-end-fill"
        scale="1.5"
        class="m-2"
        @click="skipAutoPart()"
        variant="success"
      ></b-icon>

      <b-col class="scroll-horizontal w-75 px-0">
        <b-button
          :id="'btn-work-order-' + autoPart.name"
          :ref="autoPart.name"
          v-for="(autoPart, i) in autoParts"
          :key="i"
          :variant="getItemMenuVariant(autoPart)"
          @click="selectAutoPart(autoPart)"
        >
          {{ autoPart.name }}
        </b-button>
      </b-col>
      <div>
        <b-icon
          icon="x"
          scale="1.5"
          class="m-2"
          variant="danger"
          @click="stopCamera"
        ></b-icon>
      </div>
    </b-row>
  </div>
</template>

<script>
import CompanyCarsService from "@/services/companyCarsService";

export default {
  name: "AutoParts",
  data() {
    return {
      autoParts: [],
      autoPartSelected: null,
    };
  },
  props: ["vin"],
  methods: {
    async getAutoParts() {
      const data = await CompanyCarsService.getAutoParts();
      if (this.$route.name == "company.cars.automaticInspection.easy") {
        this.autoParts = this.sortAutoPartArray();
      }
      if (this.$route.name == "company.cars.automaticInspection.easy.cr") {
        this.autoParts = this.sortAutoPartArrayFromVICR();
      } else {
        this.autoParts = data.externalPart;
      }

      this.autoPartSelected = this.autoParts[0];
      this.$emit("select-auto-part", this.autoParts[0]);
    },
    selectAutoPart(autoPart) {
      this.$emit("select-auto-part", autoPart);
      this.autoPartSelected = autoPart;
    },
    getItemMenuVariant(autoPart) {
      if (this.autoPartSelected != null) {
        return autoPart.id === this.autoPartSelected.id
          ? "success"
          : "outline-success";
      } else {
        return "outline-success";
      }
    },
    skipAutoPart() {
      let autoPartSelectedIndex = this.autoParts.indexOf(this.autoPartSelected);
      if (autoPartSelectedIndex === this.autoParts.length - 1) {
        this.selectAutoPart(this.autoParts[0]);
      } else {
        this.selectAutoPart(this.autoParts[autoPartSelectedIndex + 1]);
        location.href =
          "#btn-work-order-" + this.autoParts[autoPartSelectedIndex + 1].name;
      }
    },
    stopCamera() {
      this.$emit("stop-camera");
    },
    sortAutoPartArray() {
      let orderedArray = [
        { id: 10, name: "Odometer", type: "internal", order: 1 },
        { id: 17, name: "Tires Label", type: "external", order: 2 },
        { id: 8, name: "VIN Sticker", type: "internal", order: 3 },
        { id: 1, name: "Front Driver Seat", type: "external", order: 4 },
        { id: 11, name: "Dashboard-Wheel", type: "internal", order: 5 },
        { id: 99, name: "Rear Seats", type: "internal", order: 6 },
        { id: 90, name: "Driver Front", type: "external", order: 7 },
        { id: 91, name: "Passenger Front", type: "external", order: 8 },
        { id: 4, name: "Front Passenger Seat", type: "external", order: 9 },
        { id: 93, name: "Passenger Rear", type: "external", order: 10 },
        { id: 92, name: "Driver Rear", type: "external", order: 11 },
        { id: 12, name: "Cargo Area", type: "internal", order: 12 },
        { id: 5, name: "Roof", type: "external", order: 13 },
        { id: 6, name: "Wheel-Tire", type: "external", order: 14 },
      ];
      return orderedArray;
    },
    sortAutoPartArrayFromVICR() {
      let orderedArray = [
        { id: 10, name: "Odometer", type: "internal", order: 1 },
        { id: 17, name: "Tires Label", type: "external", order: 2 },
        { id: 8, name: "VIN Sticker", type: "internal", order: 3 },
        { id: 1, name: "Front Driver Seat", type: "external", order: 4 },
        { id: 11, name: "Dashboard-Wheel", type: "internal", order: 5 },
        { id: 99, name: "Rear Seats", type: "internal", order: 6 },
        { id: 90, name: "Driver Front", type: "external", order: 7 },
        { id: 91, name: "Passenger Front", type: "external", order: 8 },
        { id: 4, name: "Front Passenger Seat", type: "external", order: 9 },
        { id: 93, name: "Passenger Rear", type: "external", order: 10 },
        { id: 92, name: "Driver Rear", type: "external", order: 11 },
        { id: 12, name: "Cargo Area", type: "internal", order: 12 },
        { id: 5, name: "Roof", type: "external", order: 13 },
        { id: 6, name: "Wheel-Tire", type: "external", order: 14 },
      ];
      return orderedArray;
    },
  },
  mounted() {
    this.$store.commit("visualInspection/resetStore");
    this.getAutoParts();
  },
};
</script>

<style scoped>
.scroll-horizontal {
  overflow-x: auto;
  white-space: nowrap;
}
</style>
